import React from 'react';
import styled from 'styled-components';

const Badge = styled.span`
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: capitalize;
  
  ${props => props.plan === 'basic' && `
    background-color: var(--secondary-light);
    color: var(--secondary-dark);
  `}
  
  ${props => props.plan === 'family' && `
    background-color: var(--primary-light);
    color: var(--primary-dark);
  `}
`;

const PlanBadge = ({ plan }) => {
  return (
    <Badge plan={plan}>
      {plan} Plan
    </Badge>
  );
};

export default PlanBadge;
